import './response_attachment_view.js.coffee';# Added by Script 
Customer.Ticket ||= {}

class Customer.Ticket.WhatsappResponseAttachmentView extends Customer.Ticket.ResponseAttachmentView
  template: JST['backbone/templates/customer/ticket/attachment/whatsapp_response_attachment']

  add: (e, data) =>
    file = @_fileFromData data
    if !@supportedFile(file)
      showError(I18n.t('customer.dashboard.conversations.details.response.whatsapp_error.unsupported_format'))
    else
      label = new Customer.Ticket.ResponseAttachmentLabelView(@, file)
      label.render()
      @trigger('add:attachment')
      @_setLabel data, label
      @trigger('add:document:disableTextArea') if !@isImage(data)
      @_disableAddAttachmenntButton()
      @listenTo(label, 'remove:attachment', () =>
        @_enableAddAttachmenntButton()
        @trigger('remove:document:enableTextArea')
        @trigger('remove:attachment')
      )
      data.submit();
      @files.push label
      @_checkReady()

  fail: (e, data, message)=>
    label = @_labelFromData(data)
    label.destroy()
    @deleteFile(label)
    @_checkReady()
    @trigger('error:document:enableTextArea')
    showError(message)

  isImage: (data) =>
    data.files[0].type.split("/")[0] == 'image'

  supportedMimeTypes: =>
    ['pdf', 'vnd.ms-powerpoint', 'msword', 'vnd.ms-excel', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'jpeg', 'png', 'jpg', 'mp3', 'aac', 'AMR', 'ogg', 'opus', 'x-m4a']

  supportedFile: (file) =>
    @supportedMimeTypes().includes(file.type.split("/")[1])
